// Where an incident happened, for list and summary views.
// The site is the property and building the report was filed under (plus the unit, when
// one was given) — not the involved person's home address, which is often blank.

const clean = (v) => (typeof v === 'string' ? v.trim() : '');

const reportUnit = (report) => {
  const unit = clean(report?.notification?.personsInvolved?.[0]?.unitNo);
  return unit && unit.toUpperCase() !== 'N/A' ? unit : '';
};

export const getIncidentSite = (report) => {
  const title = clean(report?.propertyTitle);
  const building = clean(report?.propertyDetails?.buildingName);
  const unit = reportUnit(report);

  let site = '';
  if (title && building) {
    site = title.toLowerCase() === building.toLowerCase() ? title : `${title} · ${building}`;
  } else {
    site = title || building;
  }

  if (site) return unit ? `${site} · Unit ${unit}` : site;

  const homeAddress = clean(report?.notification?.personsInvolved?.[0]?.homeAddress);
  return homeAddress || '—';
};
